import { render, staticRenderFns } from "./matrixVideo.vue?vue&type=template&id=d686b758&scoped=true"
import script from "./matrixVideo.vue?vue&type=script&lang=js"
export * from "./matrixVideo.vue?vue&type=script&lang=js"
import style0 from "./matrixVideo.vue?vue&type=style&index=0&id=d686b758&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d686b758",
  null
  
)

export default component.exports